"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_collaborators.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CollaboratorsModal = /*#__PURE__*/function (_Component) {
  _inherits(CollaboratorsModal, _Component);

  var _super = _createSuper(CollaboratorsModal);

  function CollaboratorsModal(props) {
    var _this;

    _classCallCheck(this, CollaboratorsModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref) {
      var userId = _ref.userId,
          firstName = _ref.firstName,
          lastName = _ref.lastName,
          email = _ref.email,
          imageUrl = _ref.imageUrl,
          phoneNumber = _ref.phoneNumber;
      var displayName = "".concat(firstName, " ").concat(lastName);
      return /*#__PURE__*/_react.default.createElement("div", {
        key: userId,
        className: "client-collaborators__item"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
        imageUrl: imageUrl,
        placeholderText: displayName,
        width: "75px",
        height: "75px"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "client-collaborators__item__info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "client-collaborators__item__info__primary"
      }, displayName), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "client-collaborators__item__info__secondary"
      }, "Collaborator"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "client-collaborators__item__info__details"
      }, [phoneNumber, email].filter(Boolean).join(' | '))));
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (_ref2) {
      var value = _ref2.target.value;

      _this.setState({
        searchTerm: value
      });
    });

    _this.state = {
      collaborators: props.collaborators,
      searchTerm: ''
    };
    return _this;
  }

  _createClass(CollaboratorsModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          visible = _this$props.visible,
          onClose = _this$props.onClose;
      var _this$state = this.state,
          collaborators = _this$state.collaborators,
          searchTerm = _this$state.searchTerm;
      var members = searchTerm ? collaborators.filter(function (_ref3) {
        var firstName = _ref3.firstName,
            lastName = _ref3.lastName;
        return "".concat(firstName).concat(lastName).toLowerCase().includes(searchTerm.toLowerCase());
      }) : collaborators;
      return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: onClose,
        title: "Client Collaborators",
        onSave: onClose,
        saveText: "Back To Video"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        placeholder: "Search",
        prefix: "search",
        onChange: this.handleInputChange,
        clearButton: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "close",
          size: 10,
          color: "nevada"
        })
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "client-collaborators"
      }, members.map(this.renderItem)));
    }
  }]);

  return CollaboratorsModal;
}(_react.Component);

exports.default = CollaboratorsModal;